<template>
  <!--  id="components-layout-demo-custom-trigger" style="background: #03aa99"  style="height: 100%"-->
  <a-layout style="height:100%">
    <a-layout-sider style="overflow-y: auto;" v-model="collapsed" collapsible :trigger="null" width="255">
      <div
        class="logo"
        style="color: #FFFFFF;line-height: 32px;text-align: center;font-weight: bold"
      >
        <span v-if="!collapsed">教师资格管理信息系统</span>
      </div>
      <user-menu :IsCollapsed="collapsed" />
    </a-layout-sider>
    <a-layout>
      <a-layout-header
        class="header"
        style="  box-shadow: 0 1px 4px rgb(0 21 41 / 8%)"
      >
        <div class="header-left">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="() => (collapsed = !collapsed)"
          />
          <template>
            <!--            style="margin: 10px 0 0 16px;"-->
            <breadcrumb />

            <!--                 <a-menu v-model="current"   mode="horizontal" @select="handleSelect">-->
            <!--                    <a-menu-item key="system"> <a-icon type="mail" />工作台 </a-menu-item>-->
            <!--    &lt;!&ndash;                <a-menu-item key="monitor"> <a-icon type="appstore" />系统监控</a-menu-item>&ndash;&gt;-->
            <!--    &lt;!&ndash;                <a-menu-item key="tool"><a-icon type="appstore" />系统工具</a-menu-item>&ndash;&gt;-->
            <!--                  </a-menu>-->
          </template>
        </div>

        <!--        <routerTags/>-->

        <!--        <a-icon :type="isfullScreen?'fullscreen-exit':'fullscreen'" style="font-size: 20px" @click="ClickZoom" class="Screenfullbtn"/>-->
        <user-header :isfullScreen="isfullScreen" @handleZoom="handleZoom" />
      </a-layout-header>
      <TagsView/>
      <a-layout-content>
        <div class="cont-wrap">
          <!--          :include="includeRouter" :include="includeRouter"-->
          <keep-alive :include="cachedViews">
            <router-view :key="key" />
          </keep-alive>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
// 左侧导航
import breadcrumb from "@/components/breadcrumb.vue";
import UserMenu from "@/components/UserMenu.vue";
import UserHeader from "@/components/UserHeader.vue";

import routerTags from "@/components/routerTags.vue";

import TagsView from "@/components/layout/tabsView";

import screenfull from "screenfull";

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      collapsed: false,
      isRouterAlive: true,
      includeRouter: [],
      current: "system",
      selectedKeys: [],
      isfullScreen: false
    };
  },
  components: {
    UserMenu,
    breadcrumb,
    TagsView,
    UserHeader,
    routerTags
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
    // ...mapGetters({
    //   keepLiveTags: 'getKeepLiveTags',
    // }),
    // ...mapState(["isMenuState"])
  },
  watch: {
    // keepLiveTags:{
    //   handler(n, o) {
    //       this.includeRouter = n.map((r) => r.name);
    //   },
    //   deep: true
    // },
    // keepLiveTags() {
    //   this.includeRouter = this.keepLiveTags.map((r) => r.name)
    // },

    $route: {
      handler() {
        this.isactivekey(this.$route.fullPath);
        this.isLoading(false);

        // if(this.isMenuState == 'menu'){
        //   this.setRouterTags(this.$route);
        // }

        // const flag = this.includeRouter.some(item => item == this.$route.name);
        // if(this.isMenuState == 'tabs'){
        //   if(!flag) {
        //     this.includeRouter.push(this.$route.name);
        //
        //   }
        // }
        // else{
        //   this.includeRouter.push(this.$route.name);
        //
        // }
      },
      immediate: true
    }

    // isMenuState(val, oldVal){//普通的watch监听
    //       this.includeRouter.push('1111');
    //
    //
    //       if(val == 'tabs'){
    //
    //       }
    // },
  },
  mounted() {},
  methods: {
    ...mapActions(["setRouterTags", "isLoading"]),
    handleZoom() {
      this.isfullScreen = !this.isfullScreen;
      screenfull.toggle();
    },
    // ClickZoom(){
    //   this.isfullScreen=!this.isfullScreen
    //   screenfull.toggle();
    // },
    ...mapMutations({
      SetSidebarRouters: "SET_SIDEBAR_ROUTERS",
      isactivekey: "IS_ACTIVE_KEY"
    }),
    handleSelect(e) {
      if (e.key == "monitor") {
        const routers = [
          {
            title: "用户管理",
            path: "/model/index"
          },
          {
            title: "角色管理",
            path: "/model2/index"
          },
          {
            title: "菜单管理",
            path: ""
          }
        ];
        this.SetSidebarRouters(routers);
      } else if (e.key == "tool") {
        const routers = [
          {
            title: "表单构建",
            path: "/model/index"
          },
          {
            title: "代码生成",
            path: "/model2/index"
          },
          {
            title: "系统接口",
            path: ""
          }
        ];
        this.SetSidebarRouters(routers);
      } else {
        const routers = [
          {
            title: "系统模型",
            path: "/model/index"
          },
          {
            title: "模型管理",
            path: "/model2/index"
          },
          {
            title: "模型查询",
            path: ""
          }
        ];
        this.SetSidebarRouters(routers);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.Screenfullbtn {
  cursor: pointer;
  margin-left: 20px;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
.ant-layout-header {
  background: #ffffff;
}
.logo {
  //height: 32px;
  //background: rgba(255, 255, 255, 0.2);
  padding: 16px 0;
  border-bottom: 1px solid #ffffff;
}

.header {
  background: rgb(255, 255, 255);
  height: 50px;
  padding: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .header-left {
    display: flex;
    align-items: center;
  }
  .trigger {
    font-size: 18px;
    line-height: 50px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }
  .trigger:hover {
    color: #1890ff;
  }

  .header-msg {
    float: right;
    padding-right: 24px;
    // margin: 0 16px 0 0;
    // .user {
    //   font-size: 18px;
    // }
  }
}

.cont-wrap {
  margin: 24px 16px;
  //padding: 24px;
  background: #fff;
  min-height: 280px;
  //height: 100%;
  //height: calc(100% - 98px);
}

.ant-layout {
  background: #f1f4f6;
}

//.ant-layout {
//  width: 100%;
//  height: 100%;
////.ant-layout-header {
////  background: #00ac97;
////}
//.ant-layout-sider {
//  overflow: auto;
//  background-color: #f0f2f5;
//}
//.ant-layout-content {

//}
//}
</style>



// WEBPACK FOOTER //
// src/views/Layout.vue